<header class="w-full px-3 bg-new-nav">
  <div class="flex flex-wrap -mx-2 py-2 items-center">
    <div class="w-full sm:flex-none sm:w-1/3 px-2">
      <div class="flex items-center gap-3" *ngIf="pageIdentifier$ | async as pageIdentifier">
        <fa-icon *ngIf="pageIdentifier.sectionIcon" class="si-icon page-section-icon" [icon]="pageIdentifier.sectionIcon"></fa-icon>

        <h2 class="mb-0">{{ pageIdentifier.title }}</h2>

        <ng-container *ngIf="('favoritePage' | userMetaDataByKey | async) as favoritePage">
          <ng-container *ngIf="pageIdentifier.page">
            <button
              mat-icon-button
              [matTooltip]="favoritePage === pageIdentifier.page ? 'Currently set as your homepage' : 'Set as homepage'"
              (click)="toggleFavorite(favoritePage, pageIdentifier.page)"
              aria-label="Toggle favorite"
            >
              <mat-spinner [diameter]="20" class="inline-flex" [strokeWidth]="2" *ngIf="(isLoading$ | async); else favIcon"></mat-spinner>
              <ng-template #favIcon>
                <fa-icon
                  class="favorite-icon si-icon"
                  [icon]="favoritePage === pageIdentifier.page ? ['fas', 'star'] : ['fal', 'star']"
                ></fa-icon>
              </ng-template>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="router.url | showRightHeaderContainer : isRevdriver">
      <nav *ngIf="isLoggedIn === false" class="w-full sm:flex-none sm:w-5/6 text-right pt-2 px-2">
        <a matButton="text" class="mr-2" [href]="supportUrl" target="_blank" rel="noopener noreferrer">FAQ</a>
        <button *ngIf="router.url !== '/account/login'" matButton="outlined" type="button" class="px-6" (click)="onLogin()">Log In</button>
      </nav>
    </ng-container>

    <nav *ngIf="isLoggedIn" class="w-full text-right sm:flex-none sm:w-2/3 mb-0 px-2">
      <ul class="mb-0 list-none pl-0 flex flex-wrap items-center justify-end gap-5">
        <li *ngIf="isimpersonateHaveValue">
          <div class="bg-danger text-white py-1 px-4">
            Impersonate {{ impersonateForm.get('impersonatedEmail').value }}
          </div>
        </li>

        @let isTrial = (accountAttributesEnum.TRIAL | hasAccessAsync) | async;
        <li *ngIf="commonUtilService.hasRODCredit || isTrial" class="flex items-center gap-10">
          <a
            *ngIf="isTrial"
            class="text-si-h4 font-medium text-info"
            [href]="pricingUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Trial: {{ trialDaysLeftLabel }}
          </a>

          <button
            *ngIf="commonUtilService.hasRODCredit"
            matButton="text"
            type="button"
            class="si-cta-text"
            (click)="onOpenRodModal()"
          >
            <fa-icon class="si-icon mr-2" [icon]="['fal', 'magnifying-glass-plus']"></fa-icon>
            Research on Demand
          </button>
        </li>

        <li>
          <button matButton="text" type="button" class="si-cta-text si-menu-trigger" [matMenuTriggerFor]="menu">
            <fa-icon class="si-icon mr-2" [icon]="['fal', 'circle-question']"></fa-icon>
            <span class="si-get-help-text">Get Help</span>
            <span class="si-menu-trigger-icon" aria-hidden="true"></span>
          </button>

          <mat-menu #menu="matMenu">
            <a *ngIf="accountType === 5" [href]="trainingRequestUrl" target="_blank" rel="noopener noreferrer" mat-menu-item class="text-dark text-si-h4">Request Training</a>
            <a [href]="supportHelpCenterUrl" target="_blank" rel="noopener noreferrer" mat-menu-item class="text-dark text-si-h4">Support</a>
            <a [href]="academyUrl" target="_blank" rel="noopener noreferrer" mat-menu-item class="text-dark text-si-h4">Academy</a>
            <a [href]="statusUrl" target="_blank" rel="noopener noreferrer" mat-menu-item class="text-dark text-si-h4">System Status</a>
          </mat-menu>
        </li>

        <li *ngIf="creditLimitnRemaining" class="cursor-default text-si-h4 flex items-center" [ngClass]="expiredCredits ? 'text-danger' : 'text-dark'">
          <span
            [matTooltip]="(licenceCreditTotal > 0 && sharedCreditTotal > 0) | expiredCreditsTooltip : licenceCredit : sharedCredit"
            matTooltipClass="whitespace-pre-line"
          >
            <span [class.font-bold]="!unlimitedExports">{{ creditLimitnRemaining }}</span> credits available
          </span>
          <ng-container *ngIf="creditRevealLimitnRemaining">
            <span class="mx-3 text-muted">|</span>
            <fa-icon
              matTooltip="Credits used to view Contacts or Companies."
              aria-hidden="true"
              class="si-icon mr-2"
              [icon]="['fas', 'eye']"
            ></fa-icon>
            <span class="font-bold">{{ creditRevealLimitnRemaining }}</span>
          </ng-container>
        </li>

        <li>
          <app-overlay-dropdown [position]="['bottom-end']" #dd>
            <span
              class="user-initials-badge"
              [matTooltip]="userFullName"
              [class.cursor-pointer]="(isImpersonate || isimpersonateHaveValue)"
              dropdownTrigger
              (click)="(isImpersonate || isimpersonateHaveValue) && dd.toggle()"
            >
              {{ userInitials }}
            </span>

            <ng-template dropdownPanel>
              <div
                class="p-4 rounded-md bg-surface border border-si-border shadow-bs dropdown-panel"
                style="width: 400px"
                (mousedown)="$event.stopPropagation()"
              >
                <ng-container *ngIf="isImpersonate || isimpersonateHaveValue">
                  <form class="flex items-center gap-2" [formGroup]="impersonateForm" #impersonateFormRef="ngForm" (ngSubmit)="onImpersonate()" novalidate>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full min-w-0 mb-0 no-padding">
                      <input
                        matInput
                        type="email"
                        formControlName="impersonatedEmail"
                        placeholder="Impersonate Email"
                        required
                      >
                    </mat-form-field>
                    <div class="shrink-0">
                      <button matButton="filled" [disabled]="impersonateForm.invalid" type="submit" class="mw-auto px-3">
                        {{ isimpersonateHaveValue ? 'Clear' : 'Submit' }}
                      </button>
                    </div>
                  </form>
                </ng-container>
              </div>
            </ng-template>
          </app-overlay-dropdown>
        </li>
      </ul>
    </nav>
  </div>

  <app-overlay-loader *ngIf="companyService.isLoader"></app-overlay-loader>
</header>
